import { Component, OnInit, inject, input } from '@angular/core';
import {CoreService} from '../../../../../core/core.service';

@Component({
    selector: 'app-customerratings',
    templateUrl: './customerratings.component.html',
    styleUrls: ['./customerratings.component.scss'],
    standalone: false
})
export class CustomerratingsComponent implements OnInit {
    coreService = inject(CoreService);


    readonly modalMessageTitle = input<string>(this.coreService.getMsgkey('mws.costcenters', undefined));
    readonly c = input<any>('');
    readonly d = input<any>('');

  ngOnInit() {
  }

}
